function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M31.465,8.538L29.907,15.246C29.559,16.758 28.323,17.88 26.82,18.05L13.138,19.518L12.88,20.119C12.691,20.65 12.75,21.241 13.042,21.721C13.337,22.206 13.851,22.508 14.406,22.522L27.046,22.522C27.405,22.522 27.698,22.821 27.698,23.189C27.698,23.557 27.405,23.856 27.046,23.856L14.406,23.856C13.42,23.826 12.511,23.303 11.971,22.455C11.423,21.592 11.314,20.511 11.678,19.552L12.003,18.784L7.876,6.002C7.645,5.316 7.023,4.849 6.315,4.834L4.138,4.834C3.779,4.834 3.489,4.535 3.489,4.166C3.489,3.798 3.779,3.499 4.138,3.499L6.315,3.499C7.578,3.513 8.698,4.341 9.11,5.568L9.695,7.404L30.849,7.704C31.048,7.724 31.234,7.819 31.37,7.971C31.5,8.128 31.537,8.345 31.465,8.538ZM10.118,8.739L13.138,18.15L26.658,16.715C27.623,16.636 28.429,15.918 28.639,14.946L30.038,9.039L10.118,8.739ZM12.425,25.492C14.039,25.492 15.35,26.837 15.348,28.496C15.348,30.154 14.039,31.499 12.425,31.499C10.809,31.499 9.501,30.154 9.501,28.496C9.501,26.837 10.809,25.492 12.425,25.492ZM12.425,30.164C13.322,30.164 14.05,29.417 14.05,28.496C14.05,27.574 13.322,26.827 12.425,26.827C11.527,26.827 10.801,27.574 10.801,28.496C10.801,29.417 11.527,30.164 12.425,30.164ZM24.773,25.492C26.387,25.492 27.698,26.837 27.698,28.496C27.698,30.154 26.387,31.499 24.773,31.499C23.157,31.499 21.848,30.154 21.848,28.496C21.848,26.837 23.157,25.492 24.773,25.492ZM24.773,30.164C25.669,30.164 26.398,29.417 26.398,28.496C26.398,27.574 25.669,26.827 24.773,26.827C23.874,26.827 23.149,27.574 23.149,28.496C23.149,29.417 23.874,30.164 24.773,30.164Z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartWhite);
export default __webpack_public_path__ + "static/media/cart-white.498a3530043bfcdd554224a1d33781ca.svg";
export { ForwardRef as ReactComponent };